
/**
 * Development phase analysis utilities
 */

export function analyzeDevelopmentPhase(projectData: any, marketData: any): any {
  return {
    phaseSpecificMetrics: {
      feasibilityStatus: projectData.feasibilityStage || 'PEA',
      permitProgress: calculatePermitProgress(projectData),
      financingSecured: projectData.financingSecured || 0,
      constructionReadiness: assessConstructionReadiness(projectData)
    },
    riskProfile: {
      geologicalRisk: 25, // Much reduced
      politicalRisk: 45, // Increased due to permitting
      technicalRisk: 60, // Increased due to construction complexity
      marketRisk: 50,
      overallRisk: 45
    },
    valueDrivers: [
      { name: 'Project Economics', weight: 40, score: 75 },
      { name: 'Permitting Progress', weight: 25, score: 60 },
      { name: 'Financing Plan', weight: 20, score: 55 },
      { name: 'Management Team', weight: 15, score: 80 }
    ],
    milestoneProjections: [
      {
        name: 'FS Completion',
        timeframe: '6-9 months',
        probability: 80,
        valueImpact: 30
      },
      {
        name: 'Final Permits',
        timeframe: '12-24 months',
        probability: 65,
        valueImpact: 40
      },
      {
        name: 'Construction Start',
        timeframe: '18-30 months',
        probability: 60,
        valueImpact: 50
      }
    ],
    fundingRequirements: {
      nextPhase: 15000000,
      totalToProduction: 25000000,
      riskAdjustedNPV: 35000000
    },
    probabilityOfSuccess: 70
  };
}

function calculatePermitProgress(projectData: any): number {
  return Math.min(100, (projectData.permitProgress || 30) + Math.random() * 40);
}

function assessConstructionReadiness(projectData: any): number {
  return Math.min(100, (projectData.constructionReadiness || 20) + Math.random() * 30);
}
